import { FC, ReactElement, useCallback, useMemo } from 'react'

import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { createFloatingPaneByTypeSelector } from 'selectors/floatingPanesSelectors'
import {
  FLOATING_PANE_CRYPTO_REWARDS_PANE_TYPE,
  FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE,
  FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE,
  FLOATING_PANE_AUTO_INVESTMENTS_MODE,
  FLOATING_PANE_ORDER_DETAILS_MODE,
} from 'components/features/rewards/rewardsPane/constants/paneState'
import { CryptoRewardsPane } from 'components/features/rewards/rewardsPane/types/paneState'
import { killAllFloatingPanesActionCreator } from 'actions/floatingPanesActions'
import { CryptoRewardsBuyPane } from 'components/features/rewards/rewardsPane/containers/CryptoRewardsBuyPane/CryptoRewardsBuyPane'
import { CryptoRewardsSellPane } from 'components/features/rewards/rewardsPane/containers/CryptoRewardsSellPane/CryptoRewardsSellPane'
import { CryptoRewardsAutoInvestmentsPane } from 'components/features/rewards/rewardsPane/containers/CryptoRewardsAutoInvestmentsPane/CryptoRewardsAutoInvestmentsPane'
import { CryptoRewardsOrderDetails } from 'components/features/rewards/rewardsPane/containers/CryptoRewardsOrderDetails/CryptoRewardsOrderDetails'

export const CryptoRewardsPaneHost: FC = (): ReactElement | null => {
  const paneSelector = useMemo(createFloatingPaneByTypeSelector, [])
  const pane = useStoreSelector((state) => paneSelector(state, FLOATING_PANE_CRYPTO_REWARDS_PANE_TYPE)) as CryptoRewardsPane | null

  const dispatch = useStoreDispatch()
  const handleClose = useCallback(() => {
    dispatch(killAllFloatingPanesActionCreator())
  }, [dispatch])

  switch (pane?.mode) {
    case FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE:
      return (
        <CryptoRewardsBuyPane onClose={ handleClose } />
      )
    case FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE:
      return (
        <CryptoRewardsSellPane onClose={ handleClose } />
      )
    case FLOATING_PANE_AUTO_INVESTMENTS_MODE:
      return (
        <CryptoRewardsAutoInvestmentsPane onClose={ handleClose } />
      )
    case FLOATING_PANE_ORDER_DETAILS_MODE:
      return (
        <CryptoRewardsOrderDetails onClose={ handleClose } />
      )
  }

  return null
}
